<template lang="pug">
div(v-if="deposit" class="fow-deposit-card mb-3")
    //- QR Modal
    b-modal#depositQrModal(title="PayNow QR Code" hide-footer centered @hidden="")
        div#depositQrHolder.my-3.text-center.qrcode
            figure(style="display:flex;justify-content:center;align-items:center;")
                vue-qrcode(:value="paynowString" :options="qrOptions")
                img(src="@/assets/new_paynow.png")
            h5.text-muted(style="font-weight:500;") REF: {{ deposit.crb5c_ref }}
            h5.text-dark(style="font-weight:900;") SGD {{ deposit.crb5c_amount }}
        div.mt-4
            div.px-2.text-left.font-weight-light.my-3(style="font-size:14px;")
                p.text-dark.font-weight-normal.my-2 Payment Instructions
                p.mx-1
                    b-icon.mr-2(icon="arrow-right-circle")
                    | Scan the QR code with a mobile banking application.
                p.mx-1
                    b-icon.mr-2(icon="arrow-right-circle")
                    | Or share, save and upload the QR code to a mobile banking application.
                p.mx-1.text-muted(style="font-size:0.75rem")
                    | For iOS devices, tap the
                    b-icon.mx-1(icon="arrow-up-square")
                    | button to save or share the image.
            b-button.my-2(variant="light" @click="downloadQR" class="w-100 mb-2") Download / Share
                b-icon.ml-2(icon="download")
            b-button(variant="success" @click="onHavePaid" :disabled="confirming" class="w-100")
                span(v-if="!confirming") Done
                b-spinner(v-else small label="Processing")

    //- Card
    div(class="deposit-inner p-3 rounded")
        div(class="d-flex justify-content-between align-items-start mb-2")
            div
                p.m-0.font-weight-bold(style="font-size:0.95rem") Pending Deposit
                p.m-0.text-muted(style="font-size:0.75rem") Ref: {{ deposit.crb5c_ref }}
            span.badge.badge-pill.badge-warning Unpaid
        p.m-0.font-weight-bold.deposit-amount ${{ deposit.crb5c_amount }}
        hr.my-2
        div(class="d-flex flex-column btn-group-deposit")
            b-button(
                size="sm"
                variant="success"
                v-b-modal.depositQrModal
                class="w-100"
            ) Show PayNow QR Code
        hr.my-2
        p.text-muted.mb-0(style="font-size:0.75rem") If paid already, allow sometime for the payment to be reflected.
            //- b-button(
            //-     size="sm"
            //-     variant="info"
            //-     @click="onHavePaid"
            //-     :disabled="confirming"
            //-     class="w-100"
            //- )
            //-     span(v-if="!confirming") I have paid
            //-     b-spinner(v-else small label="Processing")
</template>

<script>
import axios from 'axios';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import PaynowQR from 'paynowqr';
import html2canvas from 'html2canvas';

export default {
    name: 'FowDepositCard',
    components: { VueQrcode },
    data() {
        return {
            deposit: null,
            confirming: false,
        };
    },
    computed: {
        paynowString() {
            if (!this.deposit) return '';
            const qrcode = new PaynowQR({
                uen: '202111519KDSG',
                amount: this.deposit.crb5c_amount,
                refNumber: this.deposit.crb5c_ref,
                company: 'Dementia Singapore Ltd. - Acc 1',
            });
            return qrcode.output();
        },
        qrOptions() {
            return {
                errorCorrectionLevel: 'H',
                color: { dark: '#7C1978' },
                width: 200,
                height: 200,
            };
        },
    },
    methods: {
        async downloadQR() {
            const qrHolder = document.querySelector('#depositQrHolder');
            if (!qrHolder) return;
            try {
                const canvas = await html2canvas(qrHolder);
                const imageUrl = canvas.toDataURL('image/png');
                const link = document.createElement('a');
                link.href = imageUrl;
                link.download = `Deposit_${this.deposit.crb5c_ref}_QR.png`;
                link.click();
            } catch (e) {
                console.error('Error downloading deposit QR:', e);
            }
        },
        async loadDeposit() {
            while (!this.$root.currentUser?.[0]) {
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
            const clientID = this.$root.currentUser[0].crb5c_client.crb5c_fow_customerid;
            if (!clientID) return;
            try {
                const { data } = await axios.get(`/api/invoices/fow-deposit/${clientID}`);
                this.deposit = data.deposit || null;
            } catch (e) {
                console.error('Failed to load FOW deposit:', e);
            }
        },
        async onHavePaid() {
            const confirmed = await this.$bvModal.msgBoxConfirm(
                'Please confirm that you have completed the PayNow payment.',
                {
                    title: 'Confirm Payment',
                    okVariant: 'success',
                    okTitle: 'Yes, I have paid',
                    cancelTitle: 'Cancel',
                    centered: true,
                }
            );
            if (!confirmed) return;
            this.confirming = true;
            try {
                await this.loadDeposit();
                if (this.deposit) {
                    this.$bvToast.toast('Payment not yet detected. Please wait a moment and try again.', {
                        title: 'Payment Pending',
                        variant: 'warning',
                        solid: true,
                    });
                } else {
                    this.$bvModal.hide('depositQrModal');
                }
            } finally {
                this.confirming = false;
            }
        },
    },
    async mounted() {
        await this.loadDeposit();
    },
};
</script>

<style lang="scss" scoped>
.fow-deposit-card {
    .deposit-inner {
        background-color: #fff8e1;
        border: 1px solid #ffffff;
    }
    .deposit-amount {
        font-size: 1.3rem;
        color: #482467;
    }
    .btn-group-deposit {
        gap: 0.5rem;
    }
}

.qrcode {
    position: relative;
}
.qrcode img {
    height: 20%;
    left: 50%;
    overflow: hidden;
    position: absolute;
    top: 35%;
    transform: translate(-50%, -50%);
}
</style>
